import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { TitleText } from 'styling/Typography'
import { IOpsWorkerStatus } from 'types/operationsControl.interface'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { ITeamPanelProps } from 'types/departmentBoard.interface'
import { CountsLine, CountValue, PanelRow, RowMain, RowMuted, RowTitle } from './DepartmentBoard.styled'

const WORKER_STATE_META: { [k in IOpsWorkerStatus['state']]: { label: string; tone: IStatusPill['status'] } } = {
  active: { label: 'Active', tone: 'success' },
  idle: { label: 'Idle', tone: 'warning' },
  break: { label: 'On break', tone: 'neutral' },
}

export const TeamPanel = ({ workers }: ITeamPanelProps) => {
  const activeCount = workers.filter((w) => w.state === 'active').length
  const idleCount = workers.filter((w) => w.state === 'idle').length
  const breakCount = workers.filter((w) => w.state === 'break').length

  return (
    <Container>
      <ContainerHeader>
        <TitleText>Team</TitleText>
      </ContainerHeader>
      <ContainerContent>
        <CountsLine>
          <span>
            <CountValue $danger={activeCount === 0}>{activeCount}</CountValue> active
          </span>
          <span>·</span>
          <span>
            <CountValue>{idleCount}</CountValue> idle
          </span>
          <span>·</span>
          <span>
            <CountValue>{breakCount}</CountValue> on break
          </span>
        </CountsLine>
        {workers.map((w) => (
          <PanelRow key={w.id}>
            <RowMain>
              <RowTitle>{w.name}</RowTitle>
              <RowMuted>{w.role}</RowMuted>
            </RowMain>
            <StatusPill status={WORKER_STATE_META[w.state].tone}>{WORKER_STATE_META[w.state].label}</StatusPill>
          </PanelRow>
        ))}
      </ContainerContent>
    </Container>
  )
}
